var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox", staticStyle: { "padding-bottom": "0" } },
    [
      _c(
        "el-row",
        { staticClass: "baseInfo", attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            _vm._b({ staticClass: "ivu-mb" }, "el-col", _vm.grid, false),
            [
              _c(
                "el-row",
                {
                  staticStyle: {
                    height: "100%",
                    background: "#fff",
                    "padding-right": "12px",
                  },
                  attrs: { type: "flex", justify: "center" },
                },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        "justify-content": "flex-end",
                        "margin-right": "20px",
                      },
                      attrs: { span: 10 },
                    },
                    [
                      _c("el-avatar", {
                        attrs: {
                          shape: "circle",
                          size: 130,
                          fit: "fill",
                          src: "https://www.douhuomall.com/static/img/aravat.png",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        "justify-content": "center",
                      },
                      attrs: { span: 10 },
                    },
                    [
                      _c(
                        "el-row",
                        {
                          staticStyle: {
                            "font-size": "22px",
                            "font-weight": "bold",
                            "margin-top": "14px",
                          },
                        },
                        [_vm._v("管理员")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        {
                          staticStyle: {
                            "margin-top": "14px",
                            "margin-bottom": "14px",
                            "font-size": "17px",
                            color: "#666666",
                            "font-weight": "bold",
                          },
                        },
                        [_vm._v(_vm._s(_vm.merData.account))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticStyle: { padding: "12px 45px" },
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.dialogVisible = true
                            },
                          },
                        },
                        [_vm._v("账户详情")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", {
                    staticStyle: {
                      display: "flex",
                      color: "#409eff",
                      "font-size": "15px",
                      "font-weight": "bold",
                      "margin-top": "55px",
                      "justify-content": "flex-end",
                    },
                    attrs: { span: 6 },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            _vm._b({ staticClass: "ivu-mb" }, "el-col", _vm.grid, false),
            [
              _c(
                "el-card",
                { attrs: { bordered: false, "dis-hover": "", padding: 12 } },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row row-between-wrapper" },
                    [
                      _c("div", { staticClass: "acea-row align-center" }, [
                        _c("span", { staticClass: "main_tit" }, [
                          _vm._v("销售额"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-tag", { attrs: { type: "primary" } }, [
                        _vm._v("今日"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.viewData
                    ? _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c(
                            "span",
                            { staticClass: "content-number spBlock my15" },
                            [_vm._v(_vm._s(_vm.viewData.sales))]
                          ),
                          _vm._v(" "),
                          _c("el-divider"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "acea-row row-between-wrapper" },
                            [
                              _c("span", { staticClass: "content-time" }, [
                                _vm._v("昨日数据"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "content-time" }, [
                                _vm._v(
                                  _vm._s(_vm.viewData.yesterdaySales) + " 元"
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            _vm._b({ staticClass: "ivu-mb" }, "el-col", _vm.grid, false),
            [
              _c(
                "el-card",
                { attrs: { bordered: false, "dis-hover": "", padding: 12 } },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row row-between-wrapper" },
                    [
                      _c("div", { staticClass: "acea-row align-center" }, [
                        _c("span", { staticClass: "main_tit" }, [
                          _vm._v("订单量"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-tag", { attrs: { type: "primary" } }, [
                        _vm._v("今日"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.viewData
                    ? _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c(
                            "span",
                            { staticClass: "content-number spBlock my15" },
                            [_vm._v(_vm._s(_vm.viewData.orderNum || 0))]
                          ),
                          _vm._v(" "),
                          _c("el-divider"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "acea-row row-between-wrapper" },
                            [
                              _c("span", { staticClass: "content-time" }, [
                                _vm._v("昨日数据"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "content-time" }, [
                                _vm._v(
                                  _vm._s(_vm.viewData.yesterdayOrderNum || 0) +
                                    "单"
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "信息",
            visible: _vm.dialogVisible,
            width: "30%",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "column" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "align-items": "center",
                    "margin-bottom": "20px",
                  },
                },
                [
                  _vm._v(
                    "\n        商户号：" +
                      _vm._s(
                        _vm.merData.retailerMerchant
                          ? _vm.merData.retailerMerchant.merchantId
                          : "-"
                      ) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "align-items": "center",
                    "margin-bottom": "20px",
                  },
                },
                [
                  _vm._v(
                    "\n        账户余额：￥" +
                      _vm._s(_vm.merData.balance) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "align-items": "center",
                    "margin-bottom": "20px",
                  },
                },
                [
                  _vm._v(
                    "\n        可选SKU数量：" +
                      _vm._s(_vm.merData.checkSkuAmount) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "align-items": "center",
                    "margin-bottom": "20px",
                  },
                },
                [
                  _vm._v(
                    "\n        商户名称：" +
                      _vm._s(_vm.merData.name) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "align-items": "center",
                    "margin-bottom": "20px",
                  },
                },
                [
                  _vm._v(
                    "\n        商户负责人：" +
                      _vm._s(_vm.merData.realName) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "align-items": "center",
                    "margin-bottom": "20px",
                  },
                },
                [
                  _vm._v(
                    "\n        手机号码：" +
                      _vm._s(_vm.merData.phone) +
                      "\n      "
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }